import React from 'react';
import { CardElement } from 'react-stripe-elements';

export const _renderCardElement =  ({ onHandleSetCardValue, onHandleChangeCardValue }) => {
  return (
    <CardElement hidePostalCode  onChange={ onHandleChangeCardValue } onReady={ onHandleSetCardValue } style={ { base: { fontSize: '18px' } } } />
  );
};



// WEBPACK FOOTER //
// ./app/components/shared/stripe/_renderCardElement.jsx